export default{
    changeAuth(state,params){
        state.auth  = params
    },
    changeProfile(state,params){
        state.profile  = params
    },
    changeOwnActive(state,params){
        state.ownActive  = params
    },
    changeCartSource(state,params){
        state.cart[params['taxonomy']]  = params.dataSource
    },
    changeCartLoading(state,params){
        state.cartLoading = params
    },
    changeCartTaxonomy(state,params){
        state.cartTaxonomy = params
    },
    changeCustomerService(state,params){
        state.customerService = params
    }        
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js